<template>
    <div class="monitor-types-cell">
        <div
            v-for="(item, index) in monitorTypesInner"
            :key="index"
        >
            {{ $t(item) }}
        </div>
    </div>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
const MONITOR_TYPES_DESC = {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    1: '与客户沟通',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    2: '与同事沟通',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    3: '群内沟通'
};
/**
 * 三种类型固定排序顺序
 */
const MONITOR_TYPES_SORT = [1, 2, 3];
export default {
    name: 'MonitorTypesCell',
    props: {
        monitorTypes: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            monitorTypesInner: this.getDisplayArray(this.monitorTypes)
        };
    },
    computed: {},
    watch: {
        monitorTypes(newValue) {
            this.monitorTypesInner = this.getDisplayArray(newValue);
        }
    },
    mounted() {},
    methods: {
        getDisplayArray(arr) {
            const retArr = [];
            /**
             * 三种类型固定排序
             */
            MONITOR_TYPES_SORT.forEach(item => {
                if (arr.indexOf(item) > -1) {
                    retArr.push(MONITOR_TYPES_DESC[item]);
                }
            });
            return retArr;
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';

.monitor-types-cell {
}
</style>
